import React, { useState } from "react";
import { Modal, Button, Alert } from "react-bootstrap";
import { FaBell, FaKey } from "react-icons/fa";
import PasswordChangeModal from "./PasswordChangeModal";

const ReminderPasswordModal = ({ show, onHide, onCancel, userId }) => {
  const [showPasswordModal, setShowPasswordModal] = useState(false);

  const handleChangePassword = () => {
    setShowPasswordModal(true);
    onHide(); // Close reminder modal
  };

  const handlePasswordChangeSuccess = () => {
    setShowPasswordModal(false);
    // Call onCancel to clear reminder flags
    onCancel();
  };

  return (
    <>
      <Modal show={show} onHide={onHide} centered backdrop="static" keyboard={false} size="md">
        <Modal.Header className="bg-info text-white">
          <Modal.Title>
            <FaBell className="me-2" />
            Password Reminder
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Alert variant="info" className="mb-3">
            <strong>Security Reminder:</strong>
          </Alert>
          <p>
            It's been 6 months since you last changed your password. 
            For better security, we recommend updating your password regularly.
          </p>
          <p className="text-muted small mb-0">
            You can skip this reminder and change your password later from your profile.
          </p>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Remind Me Later
          </Button>
          <Button variant="primary" onClick={handleChangePassword}>
            <FaKey className="me-2" />
            Change Password Now
          </Button>
        </Modal.Footer>
      </Modal>

      <PasswordChangeModal
        show={showPasswordModal}
        onHide={() => setShowPasswordModal(false)}
        onSuccess={handlePasswordChangeSuccess}
        userId={userId}
      />
    </>
  );
};

export default ReminderPasswordModal;